<template>
  <div
    :id="row.id || `summary-${row.rowSeq}`"
    :class="[rowStyle.row, row.icon && 'grid-x align-middle']"
    :aria-label="row.tooltip ? row.label + ' ' + row.value : ''"
  >
    <span :class="[rowStyle.label, row.labelClass]">
      {{ row.label
      }}<template v-if="row.tooltip">
        <button
          ref="tooltipToggleRef"
          class="tooltip-small"
          :class="row.tooltip.class"
          aria-label="More Information"
          @click="toggleTooltip($event)"
        ></button>
        <Toggletip ref="tooltipRef" position="bottom" role="tooltip" @hide="tooltipToggleRef.focus()">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-html="row.tooltip.content"></div>
        </Toggletip>
      </template>
    </span>
    <component
      :is="icon.source === 'link' ? 'img' : 'span'"
      v-if="showIcon && row.icon"
      :src="icon.source === 'link' ? getImageUrl(icon.path) : undefined"
      :alt="icon.source === 'link' ? row.altText : undefined"
      :class="[icon.class, 'margin-right-xxxs']"
      v-bind="row.icon"
    />
    <span :class="[rowStyle.value, row.valueClass]" :aria-hidden="row.screenReaderValue || undefined" v-text="row.value"></span>
    <span v-if="row.screenReaderValue" class="visibility-hidden" v-text="row.screenReaderValue"></span>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import Toggletip from '@atomic-ui/toggletip/Toggletip';

const cardImages = import.meta.glob('@/assets/img/*', { eager: true, import: 'default' });

const getImageUrl = (path) => {
  if (!path) return undefined;
  const match = Object.entries(cardImages).find(([key]) => key.endsWith(`/${path}`));
  return match ? match[1] : undefined;
};

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
  showIcon: {
    type: Boolean,
    required: false,
    default: false,
  },
  icon: {
    type: Object,
    required: false,
    default: () => {},
  },
  spaceBetween: {
    type: Boolean,
    default: false,
  },
  isV3ReturnConfirmation: {
    type: Boolean,
    default: false,
  },
  showMarginTop: {
    type: Boolean,
    default: false,
  },
});
const tooltipRef = ref(null);
const tooltipToggleRef = ref(null);

const rowStyle = computed(() => {
  if (props.spaceBetween) {
    return {
      row: 'grid-x',
      label: `cell auto medium-6 ${props.isV3ReturnConfirmation ? 'small-6' : ''}`,
      value: 'text-right medium-text-left',
    };
  }

  return {
    row: props.showMarginTop && 'margin-top-xxs',
    label: 'colon-separator margin-right-xxxs',
    value: '',
  };
});

function toggleTooltip(event) {
  tooltipRef.value.toggle(event);
}
</script>

<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/_tooltip-small.scss';
.margin-right-xxxs {
  margin-right: 0.25rem;
}
.colon-separator::after {
  content: ':';
}
.shipping-fee-tooltip {
  vertical-align: middle;
}
.card-image {
  width: rem-calc(39);
  height: rem-calc(24);
}
</style>
